import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { StaticPage } from "@/components/StaticPage";

const input = "w-full h-11 rounded-full border border-[#e5e7eb] bg-white px-5 text-[14px] text-ink placeholder:text-ink-muted focus:outline-none focus:border-gold";

export default function Contact() {
  const [form, setForm] = useState({ email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent — we’ll reply within 48h");
      setForm({ email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send your message.");
    } finally {
      setSending(false);
    }
  };

  return (
    <StaticPage title="Contact" accent="OddlyTrue" testid="contact-page">
      <div className="mt-8 bg-white border border-[#e5e7eb] rounded-2xl p-8 shadow-sm space-y-6">
        <p className="text-[15px] leading-[1.7] text-[#333]">Have a correction, birthday coincidence, or press enquiry? We read every message.</p>
        <div className="bg-paper border-l-4 border-gold rounded-r-xl p-5">
          <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-ink">Email</p>
          <p className="text-[16px] font-semibold text-ink mt-1"><a href="mailto:hello@oddlytrue.com" className="hover:text-gold">hello@oddlytrue.com</a></p>
          <p className="text-[13px] text-ink-muted mt-2">We reply within 48 hours, 9am–5pm GMT. For fastest reply, include the date or birthday you’re asking about.</p>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-ink mb-3">Send a message</p>
          <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <input data-testid="contact-email" type="email" required value={form.email} onChange={set("email")} placeholder="Your email" className={input} />
            <input data-testid="contact-subject" required value={form.subject} onChange={set("subject")} placeholder="Subject" className={input} />
            <textarea data-testid="contact-message" required value={form.message} onChange={set("message")} placeholder="Your message..." rows="5" className="w-full rounded-2xl border border-[#e5e7eb] bg-white p-4 text-[14px] text-ink placeholder:text-ink-muted focus:outline-none focus:border-gold" />
            <button data-testid="contact-submit" type="submit" disabled={sending} className="bg-ink text-white rounded-full px-6 py-3 text-[14px] font-semibold hover:bg-gold hover:text-ink transition-colors disabled:opacity-60">
              {sending ? "Sending..." : "Send message →"}
            </button>
          </form>
        </div>
        <p className="text-[11px] text-[#9ca3af] border-t border-[#e5e7eb] pt-4">OddlyTrue is an independent publication. We do not share your email.</p>
      </div>
    </StaticPage>
  );
}
